'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorCodes = exports.schemaNotFoundError = exports.rejectWithCollectionDeleted = exports.UnsuccessfulResponseException = exports.FailedRequestException = undefined;

var _wixDataErrors = require('@wix/wix-data-errors');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function rejectWithCollectionDeleted(collectionName) {
  var message = _wixDataErrors.messages.collectionDeleted(collectionName);
  return rejectWithError(message, _wixDataErrors.codes.CollectionDeleted);
}

function rejectWithError(message, code) {
  return Promise.reject((0, _wixDataErrors.wixDataError)(message, code));
}

var ExtendableError = function (_Error) {
  _inherits(ExtendableError, _Error);

  function ExtendableError(message, Class) {
    _classCallCheck(this, ExtendableError);

    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.setPrototypeOf(_this, Class.prototype);
    _this.name = Class.name;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, Class);
    } else {
      _this.stack = new Error(message).stack;
    }
    return _this;
  }

  return ExtendableError;
}(Error);

var FailedRequestException = function (_ExtendableError) {
  _inherits(FailedRequestException, _ExtendableError);

  function FailedRequestException(reason) {
    _classCallCheck(this, FailedRequestException);

    var _this2 = _possibleConstructorReturn(this, (FailedRequestException.__proto__ || Object.getPrototypeOf(FailedRequestException)).call(this, reason, FailedRequestException));

    _this2.reason = reason;
    _this2.message = reason;
    return _this2;
  }

  return FailedRequestException;
}(ExtendableError);

var UnsuccessfulResponseException = function (_ExtendableError2) {
  _inherits(UnsuccessfulResponseException, _ExtendableError2);

  function UnsuccessfulResponseException(status, responseText, message, requestId) {
    _classCallCheck(this, UnsuccessfulResponseException);

    var _this3 = _possibleConstructorReturn(this, (UnsuccessfulResponseException.__proto__ || Object.getPrototypeOf(UnsuccessfulResponseException)).call(this, message, UnsuccessfulResponseException));

    _this3.status = status;
    _this3.responseText = responseText;
    _this3.requestId = requestId;
    return _this3;
  }

  return UnsuccessfulResponseException;
}(ExtendableError);

exports.FailedRequestException = FailedRequestException;
exports.UnsuccessfulResponseException = UnsuccessfulResponseException;
exports.rejectWithCollectionDeleted = rejectWithCollectionDeleted;
exports.schemaNotFoundError = _wixDataErrors.schemaNotFoundError;
exports.errorCodes = _wixDataErrors.codes;